import React, { useEffect } from "react";
import { useMutation } from "@apollo/react-hooks";
import { useParams } from "react-router-dom";
import { Loader } from "../../components";
import { POST_VERIFY_VERIFICATION_TOKEN } from "../../queries";

const ScheduleVerifyToken = ({ RenderSuccess, RenderFailure }) => {
  const { verification_token = "", group_code = "" } = useParams();

  const [checkVerificationCode, { data, loading }] = useMutation(
    POST_VERIFY_VERIFICATION_TOKEN
  );

  /**
   * Check verification code
   */
  useEffect(() => {
    if (!verification_token) return;

    checkVerificationCode({
      variables: {
        body: {
          verification_token
        }
      }
    });
  }, [verification_token]);

  if (loading || !data) return <Loader />;

  const { verifyVerificationToken = {} } = data;

  return (
    <>
      {verifyVerificationToken.status === "success" ? (
        <RenderSuccess
          groupCode={group_code}
          verificationToken={verification_token}
        />
      ) : (
        <RenderFailure
          verificationToken={verification_token}
          groupCode={group_code}
        />
      )}
    </>
  );
};

export { ScheduleVerifyToken };
